import makeApiCall from "../master/axiosIndex";
const paymentDashboardApis = {
    fetchPaymentAnalytics: (sites:any,contractors:any,suppliers:any,fromDate: string, toDate: string): Promise<any> => {
        return makeApiCall<any>({
            method: "get",
            url: `/dashboard/paymentAnalytics/fetchPaymentAnalytics?sites=${sites}&contractors=${contractors}&supplierIds=${suppliers || ''}&fromDate=${fromDate}&toDate=${toDate}`,
        })
    },
    fetchImmediatePayments: (sites:any,contractors:any,suppliers:any): Promise<any> => {
       return makeApiCall<any>({
           method: "get",
           url: `/dashboard/paymentAnalytics/fetchImmediatePayments?sites=${sites}&contractors=${contractors}&supplierIds=${suppliers || ''}`,
       }) 
    },
    fetchOverDueAgingAnalysis: (sties:any,contractors:any,suppliers:any,fromDate: string, toDate: string): Promise<any> => {
        return makeApiCall<any>({
            method: "get",
            url: `/dashboard/paymentAnalytics/fetchOverDueAgingAnalysis?sites=${sties}&contractors=${contractors}&supplierIds=${suppliers || ''}&fromDate=${fromDate}&toDate=${toDate}`,
        })
    }
    ,fetchMonthOnMonthOverDueAgingAnalysis: (sties:any,contractors:any,suppliers:any, toDate: string): Promise<any> => {
        return makeApiCall<any>({
            method: "get",
            url: `/dashboard/paymentAnalytics/monthOnMonthOverDueAgingAnalysis?sites=${sties}&contractors=${contractors}&supplierIds=${suppliers || ''}&date=${toDate}`,
        })
    },
    fetchMonthOnMonthOverDueAgingSupplierWiseList: (sties:any,contractors:any,suppliers:any, fromDate: string, toDate: string): Promise<any> => {
        return makeApiCall<any>({
            method: "get",
            url: `/dashboard/paymentAnalytics/monthOnMonthOverDueAgingSupplierWiseList?sites=${sties}&contractors=${contractors}&supplierIds=${suppliers || ''}&fromDate=${fromDate}&toDate=${toDate}`,
        })
    },

}

export default paymentDashboardApis